import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { BaseDialog, TDialogAction } from '@mgm/common/components/base';
import { useAppDispatch, useAppSelector } from '../../../../hooks/useAppStore';
import { getIsOpenDeleteShiftDialog, getSelectedScheduleShift } from '../../../../store/schedules/selectors';
import { schedulesActions } from '../../../../store/schedules/slice';
import { useDeleteScheduleShiftAPI } from '../../../../hooks/api/useSchedules';
import { TScheduleShift } from '../../../../types';
import { getAuthenticateUser } from '../../../../store/authenticate/selectors';

const DeleteShiftDialog = () => {
  const { mutateAsync: deleteMutate, isLoading } = useDeleteScheduleShiftAPI();
  const isOpenDialog = useAppSelector(getIsOpenDeleteShiftDialog);
  const { personnel } = useAppSelector(getAuthenticateUser);

  const selectedShift = useAppSelector(getSelectedScheduleShift);
  const dispatch = useAppDispatch();
  const { t } = useTranslation(['common', 'timesheets', 'schedule']);

  const handleClose = () => {
    dispatch(schedulesActions.setIsOpenDeleteShiftDialog(false));
    dispatch(schedulesActions.setSelectedScheduleShift({} as TScheduleShift));
  };

  const deleteShift = async () => {
    const shiftData = {
      id: Number(selectedShift.id),
      start: selectedShift.start,
    };

    await deleteMutate(shiftData);
    handleClose();
  };

  const dialogActions: Array<TDialogAction> = useMemo(() => [
    {
      label: t('cancel'),
      variant: 'outlined',
      color: 'primary',
      isDisabled: isLoading,
      onClick: () => handleClose(),
    },
    {
      label: t('delete'),
      color: 'primary',
      isLoading,
      onClick: () => deleteShift(),
    },
  ], [isLoading, selectedShift.id]);

  const name = selectedShift.email === personnel.email ? t('your', { ns: 'schedule' }) : selectedShift.name;

  return (
    <BaseDialog
      dialogTitle={t('deleteShift', { ns: 'timesheets' })}
      isOpenDialog={isOpenDialog}
      dialogContent={t('areYouSureYouWantToDelete', { ns: 'timesheets', name })}
      handleClose={handleClose}
      dialogActions={dialogActions}
    />
  );
};

export {
  DeleteShiftDialog,
};
